<template>
    <button
        class="a-button"
        :class="{
            'a-button--disabled': disabled,
            'a-button--iconOnly': !!icon && !$slots.default,
            'a-button--icon': !!icon && !!$slots.default,
            'a-button--light': type === 'light',
            'a-button--light a-button--square': type === 'square',
            'a-button--fullwidth': type === 'fullwidth',
            'a-button--light a-button--fullwidth': type === 'fullwidth-light',
            'a-button--processing': processing || isProcessing
        }"
        :disabled="disabled"
        @click="handleClick($event)"
        :type="submit === true ? 'submit' : 'button'"
    >
        <a-icon v-if="icon" :icon="icon" class="a-button__icon" />
        <slot></slot>
        <a-icon
            v-if="processing || isProcessing"
            icon="SpinnerSmall"
            class="a-button__spinner"
        />
    </button>
</template>

<script>
export default {
    data() {
        return {
            processing: false
        }
    },
    props: {
        icon: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        },
        isProcessing: {
            type: Boolean,
            default: false
        },
        // if true then prevent event emitting
        // and show spinner
        processOnClick: {
            type: Boolean,
            default: false
        },
        submit: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleClick($event) {
            if (!this.processing) {
                this.$emit('click', $event)
            }
            if (this.processOnClick) {
                this.processing = true
            }
        }
    }
}
</script>
